const RANKING = [
  { rank: 1, title: '娱乐圈年度最大爆料合集 · 全程高能', views: '1,892万', icon: 'ri-fire-fill', iconColor: 'text-accent-500' },
  { rank: 2, title: '网红圈不为人知的秘密 · 全网独家', views: '1,654万', icon: 'ri-fire-fill', iconColor: 'text-accent-500' },
  { rank: 3, title: '综艺节目未播出片段泄露 · 超劲爆', views: '1,437万', icon: 'ri-fire-fill', iconColor: 'text-accent-500' },
  { rank: 4, title: '明星私生活大起底 · 48分钟完整版', views: '1,203万', icon: 'ri-fire-line', iconColor: 'text-primary-500' },
  { rank: 5, title: '音乐圈抄袭事件全纪录 · 铁证如山', views: '987万', icon: 'ri-fire-line', iconColor: 'text-primary-500' },
  { rank: 6, title: '体育圈内幕深度追踪 · 独家系列', views: '821万', icon: 'ri-fire-line', iconColor: 'text-primary-500' },
  { rank: 7, title: '2026上半年黑料视频TOP100盘点', views: '756万', icon: 'ri-fire-line', iconColor: 'text-primary-500' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">热度排行</h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">黑料视频全网播放量实时排行榜，看看大家都在追什么</p>
        </div>

        <div className="bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden">
          <div className="p-4 md:p-5 border-b border-background-200/60 flex items-center gap-4">
            <div className="flex items-center gap-2">
              <span className="w-2.5 h-2.5 rounded-full bg-accent-500 animate-pulse"></span>
              <span className="text-xs font-medium text-foreground-700 whitespace-nowrap">实时更新</span>
            </div>
            <span className="text-xs text-foreground-500">更新时间：2026-07-20 14:30</span>
          </div>

          <div>
            {RANKING.map((item, idx) => (
              <a
                key={idx}
                href="#"
                className={`flex items-center gap-3 md:gap-4 p-4 md:p-5 cursor-pointer hover:bg-background-100 transition-colors ${
                  idx < RANKING.length - 1 ? 'border-b border-background-200/40' : ''
                }`}
              >
                <div className={`w-8 h-8 md:w-9 md:h-9 rounded-lg flex items-center justify-center flex-shrink-0 font-bold text-sm ${
                  item.rank === 1 ? 'bg-accent-500 text-background-50' :
                  item.rank === 2 ? 'bg-accent-100 text-accent-700' :
                  item.rank === 3 ? 'bg-primary-100 text-primary-700' :
                  'bg-secondary-100 text-secondary-900'
                }`}>
                  {item.rank}
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <i className={`${item.icon} ${item.iconColor} text-xs`}></i>
                    <p className="text-sm font-medium text-foreground-800 truncate">{item.title}</p>
                  </div>
                  <p className="text-xs text-foreground-500">{item.views} 次播放</p>
                </div>

                <div className="flex items-center gap-2 flex-shrink-0">
                  <span className="text-xs text-foreground-500 whitespace-nowrap">观看</span>
                  <i className="ri-arrow-right-s-line text-foreground-400"></i>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}